import { render, staticRenderFns } from "./summary_trucktrack.vue?vue&type=template&id=3f1c4d8c&scoped=true&"
import script from "./summary_trucktrack.vue?vue&type=script&lang=js&"
export * from "./summary_trucktrack.vue?vue&type=script&lang=js&"
import style0 from "./summary_trucktrack.vue?vue&type=style&index=0&id=3f1c4d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1c4d8c",
  null
  
)

export default component.exports